/**
 * ColumnToggle - View button with column visibility dropdown
 * Matches ProctorV2/ColumnToggle design
 */
import React, { useState, useRef, useEffect } from 'react'
import { BsChevronDown } from 'react-icons/bs'
import { Form } from 'react-bootstrap'
import styles from '../../LabsV2.module.css'

// Available columns that can be toggled
const TOGGLEABLE_COLUMNS = [
  { id: 'name', label: 'Name' },
  { id: 'rollNo', label: 'Roll No' },
  { id: 'newIP', label: 'New IP Address' }
]

const ColumnToggle = ({ visibleColumns, onColumnsChange }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  // Check if all columns are selected
  const allSelected = TOGGLEABLE_COLUMNS.every(col =>
    visibleColumns.includes(col.id)
  )

  // Handle select all toggle
  const handleSelectAll = (checked) => {
    if (checked) {
      onColumnsChange(TOGGLEABLE_COLUMNS.map(col => col.id))
    } else {
      onColumnsChange([])
    }
  }

  // Handle individual column toggle
  const handleColumnToggle = (columnId, checked) => {
    if (checked) {
      onColumnsChange([...visibleColumns, columnId])
    } else {
      onColumnsChange(visibleColumns.filter(id => id !== columnId))
    }
  }

  return (
    <div className={styles.columnToggleContainer} ref={dropdownRef}>
      <button
        className={styles.viewButton}
        onClick={() => setIsOpen(!isOpen)}
      >
        View
        <BsChevronDown size={12} className={isOpen ? styles.chevronRotated : ''} />
      </button>

      {isOpen && (
        <div className={styles.columnToggleDropdown}>
          <div className={styles.columnToggleHeader}>
            TOGGLE COLUMNS
          </div>

          <div className={styles.columnCheckboxItem}>
            <Form.Check
              type="checkbox"
              id="select-all-columns-dashboard"
              label="Select All"
              checked={allSelected}
              onChange={(e) => handleSelectAll(e.target.checked)}
              className={styles.columnCheckbox}
            />
          </div>

          <div className={styles.columnToggleDivider} />

          {TOGGLEABLE_COLUMNS.map(column => (
            <div key={column.id} className={styles.columnCheckboxItem}>
              <Form.Check
                type="checkbox"
                id={`column-dashboard-${column.id}`}
                label={column.label}
                checked={visibleColumns.includes(column.id)}
                onChange={(e) => handleColumnToggle(column.id, e.target.checked)}
                className={styles.columnCheckbox}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default ColumnToggle
